const InvalidStateError = () => {
    throw new Error('Controller not initialized');
};
export default InvalidStateError;
//# sourceMappingURL=invalid-state-error.js.map